import { render, staticRenderFns } from "./StudentUserStatistics.vue?vue&type=template&id=09b185e6&scoped=true"
import script from "./StudentUserStatistics.vue?vue&type=script&lang=js"
export * from "./StudentUserStatistics.vue?vue&type=script&lang=js"
import style0 from "./StudentUserStatistics.vue?vue&type=style&index=0&id=09b185e6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b185e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09b185e6')) {
      api.createRecord('09b185e6', component.options)
    } else {
      api.reload('09b185e6', component.options)
    }
    module.hot.accept("./StudentUserStatistics.vue?vue&type=template&id=09b185e6&scoped=true", function () {
      api.rerender('09b185e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sepay/StudentUserStatistics.vue"
export default component.exports